import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from "../utils/dom.js"

export default function contatoForm() {
    const page = find("[js-page='comingsoon']");
    if (!page) return;

		console.log('teste que rodou');

    function showMessage(response) {
        const message = response.data ? response.data.message : response.message
        showToastify(message)
        comingSoonFormSubmit.reset()
        setTimeout(enabledBtn, 1000)
    }

    const btnSubmit = document.querySelector('.comingsoon-form-1 button[type=submit]')

    function disabledBtn() {
        btnSubmit.disabled = true
        btnSubmit.classList.add('disabled')
    }

    function enabledBtn() {
        btnSubmit.disabled = false
        btnSubmit.classList.remove('disabled')
    }


    const comingSoonFormSubmit = document.querySelector('.comingsoon-form-1');

    comingSoonFormSubmit &&
        comingSoonFormSubmit.addEventListener('submit', function (event) {
            event.preventDefault()
            disabledBtn()

            const formData = { nome: document.querySelector('.comingsoon-form-1 .form-group input[name=nome]').value, email: document.querySelector('.comingsoon-form-1 .form-group input[name=email]').value }

            const url = '/formulario-inscricao/'

            axios
                .post(url, JSON.stringify(formData))
                .then((response) => showMessage(response))
                .catch((response) => showMessage(response))
        })

}